import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ServicesPage = () => {
  useEffect(() => {
    // SEO Meta Tags
    document.title = '서비스 안내 - 유흥디자인랩 | 구인광고 홈페이지 제작 서비스';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '유흥디자인랩의 전문 서비스를 소개합니다. 구인광고 디자인 5만원부터, 홈페이지 제작 10만원부터. 빠른 제작, 합리적인 가격, 전문적인 결과물을 제공합니다.');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "디자인 서비스",
      "provider": {
        "@type": "ProfessionalService",
        "name": "유흥디자인랩",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com"
      },
      "areaServed": {
        "@type": "City",
        "name": "Seoul"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "디자인 서비스 목록",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "구인·구직 광고 디자인",
              "description": "박스/실장/가게 구인 전용 광고페이지 제작. 빠른 인력 충원을 위한 효과적인 디자인"
            },
            "price": "50000",
            "priceCurrency": "KRW"
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "홍보 웹사이트",
              "description": "손님 유입과 브랜드 이미지 구축을 위한 전문 홈페이지"
            },
            "price": "100000",
            "priceCurrency": "KRW"
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <div className="inline-block bg-neon-pink text-white px-4 py-1.5 rounded text-xs font-bold uppercase mb-4">
                SERVICES
              </div>
              <h1 className="text-5xl md:text-6xl font-black text-navy leading-tight mb-6">
                유흥디자인랩이<br />
                제공하는 서비스
              </h1>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                유흥업계에 특화된 두 가지 전문 서비스로 빠르고 효과적인 결과물을 제공합니다.<br />
                구인광고와 업체 홍보, 각각의 목적에 최적화된 디자인을 경험하세요.
              </p>
            </div>
          </div>
        </section>

        {/* Service 1 - 구인광고 */}
        <section className="py-20 bg-neon-light">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="order-2 lg:order-1">
                <img
                  src="https://public.readdy.ai/ai/img_res/4203a96541594c00a83afc44ee552595.jpg"
                  alt="구인광고 디자인"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
              </div>
              <div className="order-1 lg:order-2">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-white rounded-2xl shadow-lg">
                    <i className="ri-user-search-line text-neon-pink text-4xl"></i>
                  </div>
                  <h2 className="text-4xl font-black text-navy">
                    구인·구직 광고 디자인
                  </h2>
                </div>
                <p className="text-gray-700 text-lg mb-8 leading-relaxed">
                  박스/실장/가게 구인 전용 광고페이지 제작<br />
                  빠른 인력 충원을 위한 효과적인 디자인
                </p>
                <div className="bg-white rounded-2xl p-8 mb-8 shadow-lg">
                  <div className="flex items-baseline gap-2 mb-6">
                    <span className="text-5xl font-black text-neon-pink">5만원</span>
                    <span className="text-gray-500 text-lg">부터</span>
                  </div>
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-1"></i>
                      <span className="text-gray-700">전문 디자이너의 맞춤 제작</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-1"></i>
                      <span className="text-gray-700">모바일 최적화 반응형 디자인</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-1"></i>
                      <span className="text-gray-700">기본 수정 1회 포함</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-1"></i>
                      <span className="text-gray-700">빠른 제작 (2-3일 소요)</span>
                    </li>
                  </ul>
                </div>
                <button
                  onClick={scrollToContact}
                  className="bg-neon-pink text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-neon-pink/90 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
                >
                  지금 신청하기
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Service 2 - 홈페이지 */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-neon-light rounded-2xl shadow-lg">
                    <i className="ri-global-line text-neon-pink text-4xl"></i>
                  </div>
                  <h2 className="text-4xl font-black text-navy">
                    홍보 웹사이트
                  </h2>
                </div>
                <p className="text-gray-700 text-lg mb-8 leading-relaxed">
                  손님 유입과 브랜드 이미지 구축을 위한 전문 홈페이지<br />
                  업체의 가치를 높이는 프리미엄 웹사이트
                </p>
                <div className="bg-neon-light rounded-2xl p-8 mb-8 shadow-lg">
                  <div className="flex items-baseline gap-2 mb-6">
                    <span className="text-5xl font-black text-neon-pink">10만원</span>
                    <span className="text-gray-500 text-lg">부터</span>
                  </div>
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-1"></i>
                      <span className="text-gray-700">업체 맞춤형 디자인</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-1"></i>
                      <span className="text-gray-700">반응형 웹 디자인</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-1"></i>
                      <span className="text-gray-700">기본 수정 1회 포함</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-1"></i>
                      <span className="text-gray-700">SEO 최적화 기본 설정</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-1"></i>
                      <span className="text-gray-700">문의 폼 및 연락처 연동</span>
                    </li>
                  </ul>
                </div>
                <button
                  onClick={scrollToContact}
                  className="bg-navy text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-navy/90 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
                >
                  지금 신청하기
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20business%20website%20homepage%20design%20mockup%20for%20nightlife%20venue%20showing%20sophisticated%20layout%20with%20promotional%20content%20brand%20image%20gallery%20and%20contact%20information%20in%20professional%20modern%20style%20with%20premium%20aesthetic%20perfect%20for%20entertainment%20industry%20marketing&width=600&height=450&seq=service-website-detail&orientation=landscape"
                  alt="홈페이지 제작"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Additional Options */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-black text-navy mb-4">
                추가 옵션 서비스
              </h2>
              <p className="text-gray-600 text-lg">
                더 많은 기능이 필요하신가요? 맞춤 제작 서비스를 이용해보세요.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-light rounded-xl mb-6">
                  <i className="ri-image-line text-neon-pink text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">
                  프리미엄 이미지 촬영
                </h3>
                <p className="text-gray-600 mb-4">
                  전문 사진작가의 현장 촬영 및 보정 서비스
                </p>
                <p className="text-neon-pink font-bold text-lg">협의 후 결정</p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-light rounded-xl mb-6">
                  <i className="ri-video-line text-neon-pink text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">
                  홍보 영상 제작
                </h3>
                <p className="text-gray-600 mb-4">
                  SNS 및 온라인 마케팅용 영상 콘텐츠 제작
                </p>
                <p className="text-neon-pink font-bold text-lg">협의 후 결정</p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-light rounded-xl mb-6">
                  <i className="ri-settings-3-line text-neon-pink text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">
                  커스텀 기능 개발
                </h3>
                <p className="text-gray-600 mb-4">
                  예약 시스템, 회원 관리 등 특수 기능 추가
                </p>
                <p className="text-neon-pink font-bold text-lg">협의 후 결정</p>
              </div>
            </div>

            <div className="text-center mt-12">
              <button
                onClick={scrollToContact}
                className="bg-white text-navy px-8 py-4 rounded-full font-bold text-lg border-2 border-navy hover:bg-navy hover:text-white transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              >
                맞춤 견적 문의하기
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-black text-navy mb-4">
                왜 유흥디자인랩을 선택해야 할까요?
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-neon-light rounded-2xl mx-auto mb-6">
                  <i className="ri-flashlight-line text-neon-pink text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">빠른 제작</h3>
                <p className="text-gray-600 text-sm">
                  2-3일 내 빠른 제작으로<br />신속한 홍보 시작
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-neon-light rounded-2xl mx-auto mb-6">
                  <i className="ri-award-line text-neon-pink text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">전문성</h3>
                <p className="text-gray-600 text-sm">
                  유흥업계 특화<br />전문 디자이너의 노하우
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-neon-light rounded-2xl mx-auto mb-6">
                  <i className="ri-price-tag-3-line text-neon-pink text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">합리적 가격</h3>
                <p className="text-gray-600 text-sm">
                  이벤트 특가로<br />부담 없는 가격
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-neon-light rounded-2xl mx-auto mb-6">
                  <i className="ri-customer-service-2-line text-neon-pink text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">친절한 상담</h3>
                <p className="text-gray-600 text-sm">
                  1:1 맞춤 상담으로<br />완벽한 결과물 보장
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-neon-pink">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
              지금 바로 시작하세요
            </h2>
            <p className="text-white/90 text-lg mb-8">
              유흥디자인랩과 함께 성공적인 홍보를 시작해보세요.<br />
              전문가가 친절하게 상담해드립니다.
            </p>
            <button
              onClick={scrollToContact}
              className="bg-white text-neon-pink px-10 py-5 rounded-full font-bold text-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
            >
              무료 상담 신청하기
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;